export const SET_PREFERENCES = 'SET_PREFERENCES';
export const SET_GRAPH_COLORS = 'SET_GRAPH_COLORS';
